<template>
  <div class="text-center">
    <v-container :class="{'pt-10': $vuetify.breakpoint.mdAndUp}">
       <v-row justify="center">
        <v-col class="justify-center" cols="10" sm="8" md="6" lg="4" xl="4">
          <img class="logo" :src="this.$store.state.logo">
          <v-text-field
            prepend-icon="person"
            placeholder="Username..."
            v-model="username"
            v-on:keyup.enter="login"
          >
          </v-text-field>
          <v-text-field
            prepend-icon="lock"
            placeholder="Password..."
            type="password"
            v-model="password"
            v-on:keyup.enter="login"
          >
          </v-text-field>
          <v-btn block dark color="blue darken-1" @click="login" v-on:keypress.enter="login" class="my-4">
            <span>Log in</span>
          </v-btn>
          <v-btn block dark color="teal accent-4" @click="register" v-on:keypress.enter="register" class="my-4 white--text">
            <span>Register</span>
          </v-btn>
          <v-btn tile block @click="googleAuth" class="my-4 google-color">
            <v-icon left>fab fa-google</v-icon> Sign in with Google
          </v-btn>
        </v-col>
       </v-row>

      <v-dialog
        v-model="alert"
        max-width="500px"
        @keydown.enter="alert=false"
        @keydown.esc="alert=false"
      >
        <v-card>
          <v-card-title>
            Authentication Error
          </v-card-title>
          <v-card-text>
            Invalid username or password
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              color="blue darken-1"
              text
              @click="alert=false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
  import axios from'axios';
  import { createNamespacedHelpers } from 'vuex';
  const {  mapActions: authActions } = createNamespacedHelpers("auth");

  export default {
    name: 'Login',
    data() {
      return {
        username: "",
        password: "",
        alert: false,
        redirect: undefined,
      }
    },
    async beforeMount() {
      if (this.$store.state.auth.is_logged_in) {
        this.$store.commit('auth/logout');
      }
      let vars = this.getVars();
      if (vars['code'] !== undefined) {
        if (await this.google_login({
          redirect_url: window.location.href.split('/callback')[0] + '/callback',
          code: vars['code']
        })) {
          let path = this.$store.getters['auth/redirect_url'];
          console.log("Redirect to: " + path);
          this.$store.commit('auth/setRedirect', null);
          setTimeout(function() {window.location.replace(path);}, 10000);
        } else {
          this.alert = true;
        }
      }
    },
    mounted() {
      this.getRedirect();
    },
    methods: {
      ...authActions([
        'password_login',
        'google_login'
      ]),
      getVars() {
        let vars = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
          vars[key] = value;
        });
        return vars;
      },
      async login() {
        if (await this.password_login({username: this.username, password: this.password, redirect: this.redirect})) {
          let path = this.$store.getters['auth/redirect_url'];
          this.$store.commit('auth/setRedirect', null);
          window.location.replace(path);
          } else {
            this.alert = true;
          }
      },
      register() {
        this.$router.push('/register');
      },
      getRedirect() {
        let vars = this.getVars();
        if (vars['redirect'] !== undefined) {
          this.$store.commit('auth/setRedirect', vars['redirect']);
        }
      },
      googleAuth() {
        axios.get(process.env.API_URL + '/users/googlelogin?redirect_url=' + window.location.href.split('/login')[0] + '/callback').then((response) => {
          console.log(response.data.url);
          window.location.href = response.data.url;
        })
          .catch(() => {
            console.log('Google Authentication Failed');
          })
      }
    }
  }
</script>

<style scoped>

  .google-color {
    color: #4285F4;
  }

</style>



// WEBPACK FOOTER //
// src/components/auth/Login.vue